export enum holidayTypesEnum {
  HOLIDAY = 'Holiday',
  STAFF_DAY = 'Staff Day',
  FORCED_CLOSURE = 'Forced Closure'
}
